enum STATE {
  INITIAL,
  BEGIN_SEARCH,
  SEARCH_NUMBER,
  SEARCH_END,
  DASH_END,
  WILL_END // 找到横线之后，又找到了数字，到下一个非数字就应该结束
}

export default class RefParser {
  private marked: boolean;
  private lastIndex: number;
  private bigIndex: number;
  private str: string;
  private bigStr: string;
  private bigChar: string;
  private isCurNumber: boolean;
  private maxNumCount: number;
  private curNumCount: number;
  private index: number;
  private begin: number;
  private result: number[][];
  private state: STATE;
  private reg: { [key: string]: RegExp };

  constructor() {
    this.index = 0;
    this.begin = 0;
    this.state = STATE.INITIAL;
    this.bigIndex = 0;
    this.reg = {
      dash: /[-֊־᠆‐‑‒–—―﹘﹣－]/,
      end: /[.;。；]/,
      letter: /[a-z]/,
      space: /\s/,
      num: /\d/
    };

    this.maxNumCount = 3;
    this.curNumCount = 0;
    this.isCurNumber = false;
  }

  public parseIndex(str: string, bigStr: string) {
    this.str = str;
    this.bigStr = bigStr;
    this.result = [];
    this.lastIndex = str.length - 1;
    for (const stri of Object.keys(bigStr)) {
      this.bigIndex = Number(stri);
      this.bigChar = bigStr[this.bigIndex].toLowerCase();

      if (!this.reg.num.test(this.bigChar)) {
        this.isCurNumber = false;
        if (this.state === STATE.WILL_END) {
          this.markEnd(this.bigIndex - 1);
        }
      }

      if (this.reg.letter.test(this.bigChar)) {
        this.parseLetter();
      } else if (this.reg.num.test(this.bigChar)) {
        this.parseNumber();
      } else {
        if (this.reg.dash.test(this.bigChar)) {
          this.parseDash();
        } else if (this.reg.end.test(this.bigChar)) {
          this.parseEnd();
        } else {
          this.parseOther();
        }
      }

      if (
        this.bigIndex === bigStr.length - 1 &&
        this.state >= STATE.SEARCH_NUMBER
      ) {
        this.markEnd(this.bigIndex);
      }
    }
    // console.log("this.result ", this.result);
    return this.result;
  }

  public parseString(str: string, bigStr: string) {
    const index = this.parseIndex(str, bigStr);
    return index.map(([begin, end]) => bigStr.slice(begin, end + 1));
  }

  private parseLetter() {
    switch (this.state) {
      case STATE.INITIAL:
        if (this.bigChar === this.str[this.index]) {
          this.markBegin();
          this.index += 1;
        }
        return;
      case STATE.BEGIN_SEARCH:
        // 匹配成功
        if (this.bigChar === this.str[this.index]) {
          // 已经匹配完成
          if (this.index === this.lastIndex) {
            this.state = STATE.SEARCH_NUMBER;
            this.index = 0;
            return;
          }
          this.index += 1;
          return;
        }
        // 匹配失败
        this.reset();
        return;
      case STATE.SEARCH_NUMBER:
        this.reset();
        return;
      default:
        this.reset();
        return;
    }
  }

  private parseNumber() {
    switch (this.state) {
      case STATE.SEARCH_NUMBER:
        if (!this.isCurNumber) {
          this.isCurNumber = true;
          this.curNumCount += 1;
        }
        if (this.curNumCount === this.maxNumCount) {
          this.state = STATE.SEARCH_END;
        }
        break;
      case STATE.SEARCH_END:
        return;
      case STATE.DASH_END:
        this.state = STATE.WILL_END;
        return;
      case STATE.WILL_END:
        return;
      default:
        this.reset();
        break;
    }
  }

  private parseDash() {
    if (this.state === STATE.SEARCH_NUMBER || this.state === STATE.SEARCH_END) {
      this.state = STATE.DASH_END;
    }
    return;
  }

  private parseEnd() {
    if (this.curNumCount >= 2) {
      if (
        this.state === STATE.SEARCH_END ||
        this.state === STATE.SEARCH_NUMBER
      ) {
        this.markEnd(this.bigIndex - 1);
      }
    }
  }

  private parseOther() {
    switch (this.state) {
      case STATE.DASH_END:
        if (!this.reg.space.test(this.bigChar)) {
          this.markEnd(this.bigIndex - 1);
        }
      default:
        break;
    }
  }

  private reset() {
    this.index = 0;
    this.begin = 0;
    this.marked = false;
    this.curNumCount = 0;
    this.state = STATE.INITIAL;
    // 如果和首字母相等，重头匹配
    if (this.bigChar === this.str[0]) {
      this.markBegin();
      this.index += 1;
    }
  }

  private markBegin() {
    this.state = STATE.BEGIN_SEARCH;
    this.begin = this.bigIndex;
    this.marked = true;
    this.index = 0;
  }

  private markEnd(pos: number) {
    if (this.marked) {
      this.marked = false;
      this.result.push([this.begin, pos]);
      this.reset();
    }
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/services/parsers/ref-parser.ts